/**
 * Opens Shopify Inbox from [data-rav-open-inbox] triggers.
 */
(function () {
  var MAX_ATTEMPTS = 30;
  var RETRY_MS = 200;

  function queryShadowButton(root) {
    if (!root || !root.querySelector) return null;
    return (
      root.querySelector('.chat-app > button') ||
      root.querySelector('button.chat-toggle') ||
      root.querySelector('.chat-toggle') ||
      root.querySelector('button[aria-controls="chat-ui"]') ||
      root.querySelector('button[aria-label*="chat" i]') ||
      root.querySelector('button')
    );
  }

  function findChatToggle() {
    var hostIds = ['ShopifyChat', 'shopify-chat'];
    var i;
    for (i = 0; i < hostIds.length; i += 1) {
      var host = document.getElementById(hostIds[i]);
      if (!host) continue;
      var fromShadow = host.shadowRoot ? queryShadowButton(host.shadowRoot) : null;
      if (fromShadow) return fromShadow;
      var fromHost = queryShadowButton(host);
      if (fromHost) return fromHost;
    }

    var custom = document.querySelector('shopify-chat');
    if (custom) {
      var customBtn = custom.shadowRoot
        ? queryShadowButton(custom.shadowRoot)
        : queryShadowButton(custom);
      if (customBtn) return customBtn;
    }

    var legacyFrame = document.querySelector('#dummy-chat-button-iframe');
    if (legacyFrame && legacyFrame.contentWindow) {
      try {
        return legacyFrame.contentWindow.document.querySelector('button');
      } catch (e) {
        return null;
      }
    }

    return null;
  }

  function openInbox(fallbackUrl) {
    var toggle = findChatToggle();
    if (toggle) {
      toggle.click();
      return true;
    }
    if (fallbackUrl) {
      window.location.assign(fallbackUrl);
      return true;
    }
    return false;
  }

  function waitAndOpen(fallbackUrl, attemptsLeft) {
    if (openInbox(fallbackUrl)) return;
    if (attemptsLeft <= 0) return;
    window.setTimeout(function () {
      waitAndOpen(fallbackUrl, attemptsLeft - 1);
    }, RETRY_MS);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-rav-open-inbox]');
    if (!trigger) return;

    event.preventDefault();
    var fallback = trigger.getAttribute('data-rav-inbox-fallback') || '';
    waitAndOpen(fallback, MAX_ATTEMPTS);
  });
})();
